import * as React from "react";
import styled from "styled-components";
import { StyledSlider } from "./components/Slider";

export interface ISettingRangeSlider {
  value: any;
  onChange: any;
  isDragging?: boolean;
  setIsDragging?(value: boolean): void;
}

export const SettingRangeSlider = ({
  value,
  onChange,
  isDragging,
  setIsDragging
}: ISettingRangeSlider) => {
  return (
    <Wrapper>
      <StyledSlider
        onChange={onChange}
        value={value}
        isDragging={isDragging}
        setIsDragging={setIsDragging}
      />
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
